import { instance } from "./instance";

export const setClientIpHeader = (ip) => {
  if (ip) {
    return (instance.defaults.headers.common["Client-Ip"] = `${ip}`);
  }
  return (instance.defaults.headers.common["Client-Ip"] = "");
};
